
const translations = {
  // Navigation
  "nav.inicio": "Início",
  "nav.sobre": "Sobre",
  "nav.tours": "Tours",
  "nav.servicos": "Serviços",
  "nav.contacto": "Contacto",
  "nav.reservar": "Reservar",

  // Hero
  "hero.title1": "Descubra a",
  "hero.title2": "Madeira",
  "hero.title3": "Connosco",
  "hero.description": "Tours guiados, transfers e experiências únicas na Ilha da Madeira. Explore a natureza exuberante, paisagens deslumbrantes e a cultura local com segurança e conforto.",
  "hero.verServicos": "Ver Serviços",
  "hero.saberMais": "Saber Mais",

  // Booking Form
  "booking.title": "Reserva Rápida",
  "booking.tipoServico": "Tipo de serviço",
  "booking.selecioneServico": "Selecione um serviço",
  "booking.transfers": "Transfers",
  "booking.levadas": "Levadas & Trilhos",
  "booking.toursFoto": "Tours Fotográficos",
  "booking.data": "Data",
  "booking.pessoas": "Pessoas",
  "booking.pessoa": "pessoa",
  "booking.pessoasPlural": "pessoas",
  "booking.telefone": "Telefone / WhatsApp",
  "booking.pedirReserva": "Pedir Reserva",
  "booking.aProcessar": "A processar...",
  "booking.sucesso": "Pedido enviado com sucesso!",
  "booking.sucessoMsg": "Entraremos em contacto em breve.",
  "booking.erro": "Ocorreu um erro. Por favor, tente novamente.",

  // About
  "about.tag": "Sobre Nós",
  "about.title1": "A Sua",
  "about.title2": "Aventura",
  "about.title3": "na Madeira Começa Aqui",
  "about.p1": "Fazemos tours privados e transfers na Ilha da Madeira, proporcionando experiências exclusivas, confortáveis e totalmente personalizadas.\n\nSomos uma empresa de animação turística especializada em tours e transfers na Ilha da Madeira. Com mais de 15 anos de experiência, conhecemos cada recanto desta ilha paradisíaca e queremos partilhar a sua beleza consigo.",
  "about.p2": "A nossa equipa de motoristas profissionais garante experiências seguras, confortáveis e inesquecíveis. Desde as famosas levadas até aos miradouros mais espetaculares, criamos memórias que duram para sempre.",
  "about.anos": "Anos de Experiência",
  "about.turistas": "Turistas",
  "about.satisfacao": "Satisfação",
  "about.destinos": "Destinos",

  // Services
  "services.tag": "Serviços",
  "services.title1": "Os Nossos",
  "services.title2": "Serviços",
  "services.description": "Oferecemos uma variedade de tours e serviços para tornar a sua visita à Madeira inesquecível.",
  "services.saberMais": "Saber mais",
  "services.transfers.title": "Transfers",
  "services.transfers.desc": "Serviço de transfers confortável e seguro do aeroporto para o hotel e vice-versa. Também disponível para deslocações entre pontos turísticos.",
  "services.levadas.title": "Levadas & Trilhos",
  "services.levadas.desc": "Caminhadas pelas famosas levadas da Madeira. Explore a natureza exuberante e paisagens únicas da ilha com segurança.",
  "services.foto.title": "Tours Fotográficos",
  "services.foto.desc": "Capture os melhores momentos da Madeira nos locais mais fotogénicos. Ideal para entusiastas de fotografia.",

  // Tours
  "tours.tag": "Tours",
  "tours.title1": "Os Nossos",
  "tours.title2": "Tours",
  "tours.description": "Escolha entre os nossos tours mais populares e descubra o melhor da Ilha da Madeira. Disponíveis em dois horários diários para sua conveniência.",
  "tours.itinerario": "Itinerário",
  "tours.duracao": "Duração",
  "tours.grupo": "Grupo",
  "tours.ate": "Até",
  "tours.precos": "Preços por grupo:",
  "tours.ate4": "Até 4 pessoas",
  "tours.5a8": "5 a 8 pessoas",
  "tours.inclui": "Inclui:",
  "tours.transporte": "Transporte",
  "tours.escolhaHorario": "Escolha o Horário",
  "tours.manha": "Manhã",
  "tours.tarde": "Tarde",
  "tours.tour1.title": "Tour na Ilha da Madeira- Entre Miradouros e Vilas Típicas",
  "tours.tour1.subtitle": "Natureza & Aventura",
  "tours.tour1.desc": "Encante-se com a costa da Madeira, onde as famosas casas coloridas de Santana chamam atenção. Explore miradouros que revelam paisagens de tirar o fôlego e descubra a tranquilidade de diversas vilas.",
  "tours.tour2.title": "Madeira em Panorama- Passeio entre Miradouros",
  "tours.tour2.subtitle": "Paisagens & Cultura",
  "tours.tour2.desc": "Este tour leva os participantes a uma jornada pelas paisagens mais impressionantes da Madeira, passando por miradouros e vilas típicas.",

  // Tour Booking Modal
  "tourModal.title": "Reservar Tour",
  "tourModal.sucesso": "Reserva Enviada!",
  "tourModal.sucessoMsg": "Entraremos em contacto em breve para confirmar a sua reserva.",
  "tourModal.nome": "Nome Completo",
  "tourModal.nomePlaceholder": "O seu nome",
  "tourModal.email": "Email",
  "tourModal.telefone": "Telefone / WhatsApp",
  "tourModal.confirmar": "Confirmar Reserva",

  // Testimonials
  "testimonials.tag": "Testemunhos",
  "testimonials.title1": "O Que Dizem os",
  "testimonials.title2": "Nossos Clientes",
  "testimonials.t1.name": "Carlos Silva",
  "testimonials.t1.role": "Turista de Lisboa",
  "testimonials.t1.text": "Experiência incrível! O tour pelas levadas foi fantástico e o guia muito profissional. Recomendo vivamente para quem visita a Madeira.",
  "testimonials.t2.name": "Sophie Martin",
  "testimonials.t2.role": "Turista de França",
  "testimonials.t2.text": "O passeio de observação de golfinhos foi mágico! A equipa foi muito atenciosa e o serviço de transfer impecável. Voltaremos com certeza!",

  // CTA
  "cta.title": "Pronto Para a Sua Aventura na Madeira?",
  "cta.description": "Reserve agora o seu tour ou transfer e descubra porque a Madeira é conhecida como a Pérola do Atlântico.",
  "cta.reservar": "Reservar Agora",

  // Contact
  "contact.tag": "Contacto",
  "contact.title1": "Vamos",
  "contact.title2": "Planear",
  "contact.title3": "a Sua Viagem",
  "contact.description": "Entre em contacto connosco para reservar o seu tour ou transfer. Estamos disponíveis para responder a todas as suas questões e criar a experiência perfeita na Madeira.",
  "contact.email": "Email",
  "contact.telefone": "Telefone / WhatsApp",
  "contact.localizacao": "Localização",
  "contact.nome": "Nome",
  "contact.nomePlaceholder": "O seu nome",
  "contact.assunto": "Assunto",
  "contact.assuntoPlaceholder": "Ex: Reserva de Tour, Transfer, Informações...",
  "contact.mensagem": "Mensagem",
  "contact.mensagemPlaceholder": "Conte-nos sobre o tour ou transfer que deseja reservar...",
  "contact.enviar": "Enviar Mensagem",
  "contact.aEnviar": "A enviar...",
  "contact.sucesso": "Mensagem enviada com sucesso! Entraremos em contacto em breve.",
  "contact.erro": "Ocorreu um erro. Por favor, tente novamente.",

  // Footer
  "footer.description": "Empresa de animação turística especializada em tours guiados e transfers na Ilha da Madeira. Experiências autênticas e inesquecíveis desde 2010.",
  "footer.linksRapidos": "Links Rápidos",
  "footer.redesSociais": "Redes Sociais",
  "footer.direitos": "© 2025 Madeira Tours & Transfers. Todos os direitos reservados.",

  // Music
  "music.pausar": "Pausar música",
  "music.reproduzir": "Reproduzir música"
};

export default translations;
